import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import * as mobx from 'mobx';
import PropTypes from 'prop-types';
import Modal, { ModalContainer } from '../modal';
import Keyboard from '../keyboard/keyboard';
import { get } from 'lodash';

@inject('lineStore')
@observer
export default class FastAmount extends Component {

  state = {
    showBox: false
  }

  handleSelect = (amount) => {
    const basketData = this.props.lineStore.basket.basketData;
    const betType = get(basketData, 'betType', 1)

    if (betType === 1) {
      const oddsIds = [...get(basketData, 'oddsIds', new Set())]
      const odds = get(basketData, 'odds', {})
      oddsIds.forEach(id => {
        this.props.lineStore.basket.newOnOrdinarAmountInput(String(amount), id)
      })

    } else {
      this.props.lineStore.basket.newOnExpressOrSystemAmountInput(String(amount));
    }
  }

  toggleBox = () => {
    this.setState({ showBox: !this.state.showBox });
    this.props.lineStore.basket.account.clearResult();
  }

  render() {
    const { fastAmounts } = this.props.lineStore.basket.account;
    const { fastAmount } = this.props.lineStore.basket;
    return (
      <div className="basket-row">
        <div className="basket-fast-amount clearfix">
          <div className="basket-fast-amount__buttons fl_l">
            {fastAmounts.amounts.map(amount =>
              <button key={amount} className={`flat_button basket-fast-amount__button ${fastAmount.amount == amount ? 'active' : ''}`} onClick={() => this.handleSelect(amount)}>{amount}</button>
            )
            }
          </div>
          <div className="basket-fast-amount__config fl_r" onClick={this.toggleBox}>
            <span className="f-s-ico-settings"></span>
          </div>
        </div>
        {this.state.showBox ?
          <ModalContainer>
            <Modal
              styleModal={{ width: '500px' }}
              show={this.state.showBox}
              onCloseModal={this.toggleBox}
              title="Быстрые суммы"
            >
              <SettingFastAmount amounts={fastAmounts.amounts} onCloseModal={this.toggleBox} />
            </Modal>
          </ModalContainer>
          : ''}
      </div>
    )
  }
}

@inject('accountStore', 'dictStore')
@observer
class SettingFastAmount extends Component {

  state = {
    amounts: mobx.toJS(this.props.amounts),
    error: '',
    diff: ''
  }

  static contextTypes = {
    closeBox: PropTypes.func
  }

  componentDidMount() {
    this.input_0.focus();
  }

  componentWillMount() {
    // this.setState({amounts: mobx.toJS(this.props.amounts)})
  }

  inputEl = null;
  status = null;

  handleFocus = (type, st) => {
    if (st) {
      this.status = null;
      this.inputEl = null;
    } else {
      this.status = type;
      this.inputEl = this[`input_${type}`];
    }
  }

  handleKeyboard = (val) => {
    if (!this.inputEl) return false;
    this.inputEl.focus();
    if (val == 'b') {
      this.inputEl.value = this.inputEl.value.slice(0, -1);
      this.setAmount(this.status, this.inputEl.value);
    } else {
      if (this.inputEl.maxLength > this.inputEl.value.length) {
        this.inputEl.value = this.inputEl.value + String(val);
        this.setAmount(this.status, this.inputEl.value);
      }
    }
  }

  setAmount = (idx, e) => {
    const number = e.replace(/\D+/g, "");
    const _tmp = this.state.amounts;
    if (number.toString().length > 0) {
      _tmp[idx] = number;
    } else {
      _tmp[idx] = '';
    }
    this.setState({ amounts: _tmp });
  }

  save = () => {
    this.handleFocus(null, 1);
    for (const idx in this.state.amounts) {
      if (!this.state.amounts[idx]) {
        this.props.accountStore.setResult('INCORRECT_FAST_SUM');
        this[`input_${idx}`].focus();
        return false;
      }
    }

    this.props.accountStore.setFastAmount(this.state.amounts, this.props.onCloseModal);
  }

  render() {
    const { getLang } = this.props.dictStore;
    const { result, waitFastForm } = this.props.accountStore;
    return (
      <div className="fast-amount-set">
        {this.state.amounts.map((amount, idx) =>
          <div className="row" key={idx}>
            <div className="row-label">
              <label htmlFor="basket-fast-amount">{getLang('AMOUNT')} {idx + 1}</label>
            </div>
            <div className="row-data row-data-input">
              <input
                ref={el => { this[`input_${idx}`] = el }}
                className="form-control"
                type="text"
                maxLength="6"
                value={amount}
                onChange={(e) => this.setAmount(idx, e.target.value)}
                onFocus={() => this.handleFocus(idx)}
              />
            </div>
          </div>
        )
        }
        <Keyboard onChange={this.handleKeyboard} />
        <div className={`fast-amount-set__buttons clearfix ${result.status ? 'fast-amount-set_result' : ''}`}>
          <button className="flat_button fl_l" onClick={() => this.context.closeBox()}>{getLang('CANCEL')}</button>
          <button className={`flat_button fl_r ${waitFastForm ? 'wait' : ''}`} onClick={this.save} >{getLang('SAVE')}</button>
        </div>
        {result.status ? <div className="fast-amount-set__message">{getLang(result.text)}</div> : ''}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/basket/fastAmount.js